import AssigneeAggregatedStats from "seneca-common/features/assignments/features/teacher-assignments/state/models/Assignee/AggregatedStats";

export function getTotalStudyTime(state: AssigneeAggregatedStats) {
  return state.get("totalStudyTime");
}

export function getAverageScore(state: AssigneeAggregatedStats) {
  return state.get("averageScore");
}

export function getAverageNumberOfAttempts(state: AssigneeAggregatedStats) {
  return state.get("averageSessionsCompleted");
}

export function getAverageStudyTime(state: AssigneeAggregatedStats) {
  return state.get("averageStudyTime");
}

export function getAverageBestScore(state: AssigneeAggregatedStats) {
  return state.get("averageBestScore");
}

export function getAverageWorstScore(state: AssigneeAggregatedStats) {
  return state.get("averageWorstScore");
}

export function getAverageFirstScore(state: AssigneeAggregatedStats) {
  return state.get("averageFirstScore");
}

export function getAverageLastScore(state: AssigneeAggregatedStats) {
  return state.get("averageLastScore");
}

export function getSumQuestionMarks(state: AssigneeAggregatedStats) {
  return state.get("sumQuestionMarks");
}

export function getSumQuestionMarksTotal(state: AssigneeAggregatedStats) {
  return state.get("sumQuestionMarksTotal");
}
